var ttsVoice = null;
var ttsInitVoiceListCount = 50;
var ttsInitVoiceListInterval = 500;
var ttsInitVoiceListIntervalHandle = false;

window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};
window.silesia.layout.ttsPlayer = function(config) {
    var ttsPhrases = [];

    return {
        progress:{
            value:0,
            max:0
        },
        is_inited:false,
        in_progress:false,

        load:function(){
            var self = this;
            var txt = '';

            if(self.is_inited) {
                return;
            }

            if(config.src && document.querySelector(config.src)) {
                for(var el of document.querySelectorAll(config.src)) {
                    txt += ' ' + el.innerText.trim();
                }
            } else if(config.txt) {
                if(Array.isArray(config.txt)) {
                    txt = config.txt.map((v) => String(v).trim()).join(' ');
                } else {
                    txt = String(config.txt).trim();
                }
            }

            self.initVoice();
            self.initPhrases(txt);
            self.is_inited = true;
        },

        initVoice: function() {
            var self = this;

            if(ttsInitVoiceListCount<=0) {
                return;
            }

            //Prevent multiple overklaping init
            if(ttsInitVoiceListIntervalHandle) {
                return;
            }

            ttsInitVoiceListIntervalHandle = setInterval(function() {
                if(--ttsInitVoiceListCount<=0) {
                    clearInterval(ttsInitVoiceListIntervalHandle);
                    ttsInitVoiceListIntervalHandle = false;
                }
            
                if(self.loadAndGetVoice()) {
                    clearInterval(ttsInitVoiceListIntervalHandle);
                    ttsInitVoiceListIntervalHandle = false;
                }
            }, ttsInitVoiceListInterval);
        },

        initPhrases: function(txt) {
            ttsPhrases = txt.replace(/([\.\?\!]+\s*)/g,'$1###').split('###').map(function(el){return el.trim();});
            ttsPhrases = ttsPhrases.reduce(function(acc,v,k){
                if(k==0) {
                    acc[k] = v;
                } else if(acc[k-1] != null && String(acc[k-1]).length<128) {
                    acc[k-1] += v;
                    acc[k] = null;
                } else {
                    acc[k] = v;
                }
                return acc;
            },[]).filter(function(el){
                el = String(el).trim();
                return (el!='null' && el.length);
            });
        },

        loadAndGetVoice: function() {
            if (!('speechSynthesis' in window)) {
                return;
            }
        
            if(!ttsVoice) {
                var voiceList = window.speechSynthesis.getVoices();
                voiceList = Array.isArray(voiceList) ? voiceList : [];
                ttsVoice = voiceList.find(function(v){
                    return v.lang.match(/^pl.+pl$/i)
                });

                ttsVoice = (ttsVoice&&ttsVoice.lang) ? ttsVoice : null;
                if(ttsVoice) {
                    ttsInitVoiceListCount = 0;                    
                }
            }
        
            return ttsVoice;
        },

        playerHandler:function(e) {
            var self = this;

            e&&e.preventDefault();

            if(!self.loadAndGetVoice() || !ttsPhrases.length) {
                self.in_progress = false;
                self.progress.max = 0;
                self.progress.value = 0;
                return;
            }

            if(self.in_progress) {
                window.speechSynthesis.pause();
                self.in_progress = false;
            } else if(self.progress.value>0) {
                window.speechSynthesis.resume();
                self.in_progress = true;
            } else {
                self.progress.value = 0;
                self.progress.max = ttsPhrases.length;
                self.in_progress = true;

                window.speechSynthesis.cancel();

                ttsPhrases.forEach(function(v){
                    var msg = new SpeechSynthesisUtterance(v);
                    msg.voice = self.loadAndGetVoice();
                    msg.lang = msg.voice.lang;
                    msg.onstart = function(e) {
                        //self.progress.value++;
                        if(!self.progress.value) {
                            self.progress.value = 0.5;
                        }
                    }
                    msg.onend = function(e) {
                        if(self.progress.value == 0.5) {
                            self.progress.value = 1;
                        } else {
                            self.progress.value++;
                        }
                        if(self.progress.value>=self.progress.max) {
                            self.progress.value = 0;
                            self.in_progress = false;
                        }
                    }
                    window.speechSynthesis.speak(msg);
                });
            }
        }
    };
}




if(document.querySelector('*[x-data-lazy*="window.silesia.layout.ttsPlayer"]')) {
    for(var el of document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.ttsPlayer"]')) {
        el.setAttribute('x-init', 'load');
        el.setAttribute('x-data', el.getAttribute('x-data-lazy'));
        el.removeAttribute('x-data-lazy');
        el.removeAttribute('x-cloak');

        //Fix - nie chciały się p[odpiać zdarzenia ox-n:click] jeśli stosujemy dynamiczne ładowanie
        window.Alpine.initTree(el);
    };
}